import React, { useState, useEffect } from "react";
import { getAllReviews } from "../api/movie.api";
import MovieCard from "../components/MovieCard";
import DecorLine from "../components/DecorLine";
import ReelLoader from "../components/LoadingReel";

const Reviews = () => {
  const [allMovies, setMovies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const m = await getAllReviews();
        setMovies(m);
      } catch (error) {
        console.log("Error front end: " + error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="reviews-container">
      {isLoading && <ReelLoader />}
      <div className={`reviews-content ${isLoading ? "hide" : "show"}`}>
        <section className="reviews-hero-text">
          <div className="reviews-title-container">
            <div className="reviews-hero-title">
              <h1 className="reviews-hero-brand">FELICE</h1>
              <h1 className="reviews-hero-heading">REVIEWS</h1>
              <DecorLine color="var(--primary-color)" />
            </div>
          </div>
        </section>

        <div className="review-cards-list-container">
          {allMovies &&
            allMovies.map((movie) => {
              return (
                <MovieCard
                  id={movie.rid}
                  poster={movie.poster}
                  disabledLink={false}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default Reviews;
